import React, { useState, useEffect, useCallback } from 'react'
import './NearMeBanner.css'

const BOOK_URL = 'https://takeachair.com/salon-info?salonId=IHi7PDJMLomwaOqeotpm'
const SALON_LAT = 38.6316261
const SALON_LNG = -77.2721974
const NEAR_MILES = 10
const STORAGE_KEY = 'sarahadom-nearme-dismissed'

function getDistanceMiles(lat1, lon1, lat2, lon2) {
  const R = 3959
  const dLat = ((lat2 - lat1) * Math.PI) / 180
  const dLon = ((lon2 - lon1) * Math.PI) / 180
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos((lat1 * Math.PI) / 180) * Math.cos((lat2 * Math.PI) / 180) * Math.sin(dLon / 2) * Math.sin(dLon / 2)
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
  return R * c
}

export default function NearMeBanner() {
  const [show, setShow] = useState(false)
  const [checking, setChecking] = useState(false)

  const checkNearby = useCallback(() => {
    if (typeof window === 'undefined' || !navigator.geolocation) return
    if (sessionStorage.getItem(STORAGE_KEY)) return
    setChecking(true)
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const miles = getDistanceMiles(pos.coords.latitude, pos.coords.longitude, SALON_LAT, SALON_LNG)
        if (miles <= NEAR_MILES) setShow(true)
        setChecking(false)
      },
      () => setChecking(false),
      { enableHighAccuracy: false, timeout: 8000, maximumAge: 300000 }
    )
  }, [])

  const dismiss = () => {
    sessionStorage.setItem(STORAGE_KEY, '1')
    setShow(false)
  }

  useEffect(() => {
    const t = setTimeout(checkNearby, 3000)
    return () => clearTimeout(t)
  }, [checkNearby])

  if (!show || checking) return null

  return (
    <div className="nearme-banner" role="banner">
      <div className="nearme-banner-inner">
        <p className="nearme-banner-text">
          You’re nearby! Book your visit at Sarah Adom Braiding Salon.
        </p>
        <div className="nearme-banner-actions">
          <a
            href={BOOK_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="nearme-banner-cta"
          >
            Book now
          </a>
          <button type="button" onClick={dismiss} className="nearme-banner-dismiss" aria-label="Dismiss">
            ×
          </button>
        </div>
      </div>
    </div>
  )
}
